import EmployeeProfile from './EmployeeProfile';

export default EmployeeProfile;
